import { Pipe, PipeTransform } from '@angular/core';
import { TrafficLabelId, TranslationService } from 'src/app/core';

@Pipe({
  name: 'trafficLabelLogoName'
})
export class TrafficLabelLogoNamePipe implements PipeTransform {

  constructor(private translationService: TranslationService) { }

  /**
   * getTrafficLabelLogoName
   * Use [innerHTML] attribute to display the logo in template as such: [innerHTML]="icon"
   * @param trafficLabelId
   * @returns
   */
  transform(trafficLabelId?: TrafficLabelId): { logo: string, name: string } {
    const getTrafficLabelName = (trafficLabelId: TrafficLabelId) =>
      this.translationService.instant(`SOCIAL.LABELS.${trafficLabelId.toUpperCase()}`);

    switch (trafficLabelId) {
      case TrafficLabelId.FACEBOOK:
        return {
          logo: '<div class="traffic-label-logos-group"><i class="fab fa-facebook fa-lg"></i></div>',
          name: getTrafficLabelName(TrafficLabelId.FACEBOOK),
        };
      case TrafficLabelId.TWITTER:
        return {
          logo: '<div class="traffic-label-logos-group"><i class="fab fa-twitter fa-lg"></i></div>',
          name: getTrafficLabelName(TrafficLabelId.TWITTER),
        };
      case TrafficLabelId.WHATSAPP:
        return {
          logo: '<div class="traffic-label-logos-group"><i class="fab fa-whatsapp fa-lg"></i></div>',
          name: getTrafficLabelName(TrafficLabelId.WHATSAPP),
        };
      case TrafficLabelId.VPN_BRANDVNO:
        return {
          logo: `<div class="traffic-label-logos-group"><img src="/assets/images/logos/traffic-labels/rappi.svg" alt="${this.translationService.instant('SOCIAL.LABELS.'+trafficLabelId+'')}" class="traffic-label-logo" /></div>`,
          name: getTrafficLabelName(TrafficLabelId.VPN_BRANDVNO),
        };
      default: // General
        return {
          logo: '<div class="traffic-label-logos-group"><i class="far fa-globe fa-lg"></i></div>',
          name: getTrafficLabelName(TrafficLabelId.GENERAL),
        };
    }
  }

}
